module.exports = __webpack_public_path__ + "img/dzjqr-qr.8d649882.png";